export default {
  /**
   * 数字をカンマ区切りで表示
   * @param {Integer} num 数字
   */
  toNumComma(num: number) {
    if (num === null || num === undefined) {
      return '';
    } else {
      const int_comma = (num + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      return int_comma;
    }
  },
  pad(num: number, size: number) {
    const s = "00000000000000000000" + num;  // ゼロ20個
    return s.substring(s.length-size);
  },
  getYearAndMonth(d: Date) {
    return {
      year: `${d.getFullYear()}`,
      month: `0${d.getMonth() + 1}`.slice(-2),
    }
  },
  getPrevYearAndMonth(d: Date) {
    const next_d = new Date(d.getFullYear(), d.getMonth() - 1, 1);
    return {
      year: next_d.getFullYear() + '',
      month: this.pad(next_d.getMonth() + 1, 2),
    }
  },
  getNextYearAndMonth(d: Date) {
    const next_d = new Date(d.getFullYear(), d.getMonth() + 1, 1);
    return {
      year: next_d.getFullYear() + '',
      month: this.pad(next_d.getMonth() + 1, 2),
    }
  },
  getYearList() {
    return Array.from(Array(10), (v, k) => `${k + 2024}`)
  },
  getMonthList() {
    return Array.from(Array(12), (v, k) => this.pad(k + 1, 2))
  },
  /**
   * iframeの内容を印刷する
   * @param {String} idFrame iframeのID
   */
  printIframeContent(idFrame: string) {
    const ele = document.getElementById(idFrame) as HTMLIFrameElement
    if (ele) {
      const frm = ele.contentWindow;
      if (frm) {
        frm.focus();
        frm.print();
      }
    }
    return false;
  },
  /**
   * 日付をフォーマットする
   * @param {Date} date 
   * @param {String} format 
   */
  formatDate(date: Date | string, format: string) {
    if (!format) {
        format = 'YYYY-MM-DD hh:mm:ss.SSS';
    }
    if (!date) {
      return null;
    } else if (typeof date === "string") {
        date = new Date(date);
    }
    format = format.replace(/YYYY/g, '' + date.getFullYear());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    if (format.match(/S/g)) {
        const milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
        const length = format.match(/S/g)?.length || 0;
        for (let i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
    }
    return format;
  },

}